/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type CreateCategoryDto = {
  /**
   * Category name
   */
  name: string;
  /**
   * Category code
   */
  code: string;
  /**
   * Category description
   */
  description?: string;
  /**
   * Category status
   */
  status: CreateCategoryDto.status;
  /**
   * Source of creation
   */
  source?: CreateCategoryDto.source;
};
export namespace CreateCategoryDto {
  /**
   * Category status
   */
  export enum status {
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE',
  }
  /**
   * Source of creation
   */
  export enum source {
    CATALOG = 'CATALOG',
    SETTINGS = 'SETTINGS',
  }
}
